import { put, call, takeLatest, takeEvery, all } from 'redux-saga/effects';
import * as types from './actionsTypes.analytics';
import * as errorSaga from '../errors/saga.errors';
import Api from '../../api/Api';
import billingEvents from '../../const/billingEvents';
import { reachMetrikaGoal } from '../../services/MetrikaService';
import { actions as planActions } from '../../const/plansAnalytics';

export function* watch() {
    yield takeEvery(types.TRACK_PAYMENT_REQ, trackPaymentStart);
    yield takeEvery(types.TRACK_PAYMENT_OK, trackPaymentSuccess);
    yield takeEvery(types.TRACK_PAYMENT_ERR, trackPaymentError);
    yield takeEvery(types.TRACK_USER_ACTION_REQ, trackUserAction);
    yield takeEvery(types.TRACK_PLAN_ACTION_REQ, trackPlanAction);
}

export function* trackPaymentStart(paymentAnalyticsInfo) {
    try {
        console.info('PAYMENT ANALYTICS', 'start', JSON.stringify(paymentAnalyticsInfo, null, '  '));

        yield call(Api.storePaymentAnalytics, paymentAnalyticsInfo);

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* trackPaymentError(paymentAnalyticsInfo) {
    try {
        console.info('PAYMENT ANALYTICS', 'error', JSON.stringify(paymentAnalyticsInfo, null, '  '));

        yield call(Api.storePaymentAnalytics, paymentAnalyticsInfo);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* trackPaymentSuccess(paymentAnalyticsInfo) {
    try {

        const info = { ...paymentAnalyticsInfo, paymentStatus: billingEvents.paymentSuccessful };

        reachMetrikaGoal('paymentSuccess');

        console.info('PAYMENT ANALYTICS', 'success', JSON.stringify(info, null, '  '));

        yield call(Api.storePaymentAnalytics, info);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* trackUserAction({ action, hex, data, email, resolve, reject }) {
    try {
        const param = {
            action,
            ts: Date.now(),
            hex,
            data: JSON.stringify({ ...data, email })
        };

        console.info('USER ANALYTICS', JSON.stringify(param, null, '  '));

        yield call(Api.storeUserAnalytics, param);

        resolve();
    } catch (error) {
        yield errorSaga.putError(error);
        reject();
    }
}

export function* trackPlanAction({ page, action, newPlanId, newPlanName, params, code, resolve, reject }) {
    try {
        const param = {
            page,
            action,
            newPlanId,
            newPlanName,
            params,
            code
        };

        console.info('PLAN ANALYTICS', JSON.stringify(param, null, '  '));

        if (action === planActions.confirmPlan) {
            yield call(Api.storeInitPlanAnalytics, param);
        } else {
            yield call(Api.storePlanAnalytics, param);
        }

        if (resolve) {
            resolve();
        }
    } catch (error) {
        yield errorSaga.putError(error);
        if (reject) {
            reject();
        }
    }
}
